export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "name_en": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name (English)"])}
        },
        "name_fr": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name (French)"])}
        },
        "means_approved": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Does this status mean the ", _interpolate(_named("type")), " is approved?"])}
        },
        "means_request_approval": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Does this status mean the ", _interpolate(_named("type")), " is requesting approval?"])}
        },
        "means_active": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Does this status mean the ", _interpolate(_named("type")), " is active?"])}
        },
        "default_status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is this the default status to be applied?"])}
        },
        "skill_set_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skill set"])},
        "skill_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["skill"])},
        "training_standard_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["training standard"])}
      },
      "fr": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement..."])},
        "network": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réseau"])},
        "container_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type de conteneur"])},
        "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Récipient"])},
        "name_en": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom (Anglais)"])}
        },
        "name_fr": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom (Français)"])}
        },
        "means_approved": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Est-ce que ce statut veut dire que le ", _interpolate(_named("type")), " est approuvé ?"])}
        },
        "means_request_approval": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Est-ce que ce statut veut dire que le ", _interpolate(_named("type")), " est en demande d'approbation ?"])}
        },
        "default_status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Est-ce le statut par défaut à appliquer ?"])}
        },
        "skill_set_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'ensemble de compétences"])},
        "skill_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["compétence"])},
        "means_active": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Est-ce que ce statut veut dire que le ", _interpolate(_named("type")), " est actif ?"])}
        },
        "training_standard_status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["norme de formation"])}
      }
    }
  })
}